// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__w7wSK","modalForm":"UpgradeEpcsModal_modalForm__3NaAY","modalFooter":"UpgradeEpcsModal_modalFooter__K9raF"};